import configs from '@/configs'
import { isProductionMode } from '@/utils/environmentUtils'

import { ready } from './core/ready'
import bridge from './index'

export async function init(callback: Function) {
  const isReady = await ready()

  if (isReady) {
    ;(window as any).idvu = bridge
    callback()
  } else if (!isProductionMode) {
    const { default: mock } = await import(/* webpackChunkName: "mock" */ './mock')
    ;(window as any).idvu = mock
    callback()

    return
  } else {
    window.location.replace(configs.OFFICIAL_HOMEPAGE)
  }
}
